import { render, staticRenderFns } from "./prjAddProjectComponentDialog.vue?vue&type=template&id=11e3a70b"
import script from "./prjAddProjectComponentDialog.vue?vue&type=script&lang=js"
export * from "./prjAddProjectComponentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports